import "./App.css";
import { BrowserRouter } from "react-router-dom";

import React from "react";
import AppRoutes from "./AppRoutes";
import Localization from "./localization/localization";

function App() {
    return (
        <BrowserRouter>
            <Localization>
                <AppRoutes />
            </Localization>
        </BrowserRouter>
    );
}

export default App;
